const ones = [
    "", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf",
    "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize",
    "dix-sept", "dix-huit", "dix-neuf"
];

const tens = ["", "", "vingt", "trente", "quarante", "cinquante", "soixante"];

function getBelowHundred(n) {
    if (n < 20) return ones[n];
    if (n < 70) {
        const ten = Math.floor(n / 10);
        const unit = n % 10;
        if (unit === 1 && ten >= 2 && ten <= 6) return `${tens[ten]} et un`;
        return `${tens[ten]}${unit ? "-" + ones[unit] : ""}`;
    }
    if (n < 80) return `soixante-${getBelowHundred(n - 60)}`;
    if (n < 100) {
        const base = "quatre-vingt";
        if (n === 80) return base + "s";
        return `${base}-${getBelowHundred(n - 80)}`;
    }
    return "";
}

function getBelowThousand(n) {
    if (n < 100) return getBelowHundred(n);
    const hundred = Math.floor(n / 100);
    const rest = n % 100;
    let prefix = hundred === 1 ? "cent" : ones[hundred] + " cent";
    if (rest === 0 && hundred > 1) prefix += "s";
    return rest ? `${prefix} ${getBelowHundred(rest)}` : prefix;
}

export const numberToWordsFrench = (num) => {
    if (num === 0) return "ZÉRO";
    if (num < 0) return "MOINS " + numberToWordsFrench(-num);

    const parts = [];
    const milliards = Math.floor(num / 1_000_000_000);
    if (milliards) {
        parts.push(`${numberToWordsFrench(milliards)} milliard${milliards > 1 ? "s" : ""}`);
        num %= 1_000_000_000;
    }
    const millions = Math.floor(num / 1_000_000);
    if (millions) {
        parts.push(`${numberToWordsFrench(millions)} million${millions > 1 ? "s" : ""}`);
        num %= 1_000_000;
    }
    const milliers = Math.floor(num / 1000);
    if (milliers) {
        parts.push(milliers === 1 ? "mille" : `${numberToWordsFrench(milliers)} mille`);
        num %= 1000;
    }
    if (num > 0) parts.push(getBelowThousand(num));
    return parts.join(" ").trim().toUpperCase();
};

export const formatCurrencyWithCurrencyCode = (amount, locale = 'fr-FR', currency = 'XOF') => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
};

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR').format(amount);
};

export const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
};
